import { render } from "./aporte_titulo_donacion.vue?vue&type=template&id=f0d535e2"
import script from "./aporte_titulo_donacion.vue?vue&type=script&lang=js"
export * from "./aporte_titulo_donacion.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__